<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="row col-12 text-brand-5" @click="voltar()">
        <q-icon size="sm" name="arrow_back_ios" class="cursor" />
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Listagem de Permissões: {{ detalhesRole.name }}
        </p>
      </div>
    </div>
    <div class="q-mt-xl">
      <div
        class="row col-12 texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
      >
        Adicionar/Remover Permissões
      </div>
      <div
        class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-lg q-ml-md container-input-search"
      >
        <q-input
          rounded
          outlined
          dense
          debounce="300"
          class="col-md-3 col-xs-12"
          v-model="busca"
          type="text"
          placeholder="Pesquisar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
      <q-table
        :columns="columns"
        :rows="permissoes"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        dense
        selection="multiple"
        class="tabela-tamanho-fixo"
        :loading="loading"
        row-key="id"
        v-model:selected="selected"
        :grid="$q.screen.lt.sm"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="q-ml-sm q-mt-sm"
                    ><strong>Nome: </strong>{{ props.row.name }}</span
                  >
                </div>
                <div class="col-2">
                  <div>
                    <q-toggle
                      v-model="props.selected"
                      @click="verificarEstado(props.row.id)"
                      :disable="disable"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr>
            <q-td>
              <q-toggle
                v-model="props.selected"
                @click="verificarEstado(props.row.id)"
                :disable="disable"
              />
            </q-td>
            <q-td class="text-brand-5 text-weight-bold">
              {{ props.row.name }}
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "desativar/ativar",
    label: "Desativar/Ativar",
    align: "left",
  },
  {
    name: "permissao",
    label: "Permissão",
    align: "left",
  },
];
export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();
    const router = useRouter();

    const roleId = route.params.roleId;
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let loading = ref(false);
    const detalhesRole = ref([]);
    const selected = ref([]);
    const permissoes = ref([]);
    const busca = ref("");

    const listarRole = async () => {
      const response = await store.dispatch("perfis/listarPermissoesRole", {
        role_id: roleId,
      });
      detalhesRole.value = response.data.model;
      selected.value = response.data.model.permissions;
    };

    const listarPermissoes = async () => {
      disable.value = true;
      loading.value = true;
      const response = await store.dispatch("perfis/listarPermissoes", {
        nome: busca.value,
        per_page: 1000,
      });
      permissoes.value = response.data.results.data;
      disable.value = false;
      loading.value = false;
    };

    const paginarTabela = async () => {
      listarPermissoes(pagination.value.page, pagination.value.rowsPerPage);
    };

    const verificarEstado = async (id) => {
      if (selected.value.some((permissao) => permissao.id == id)) {
        ativarPermissao(id);
      } else {
        desativarPermissao(id);
      }
    };

    const ativarPermissao = async (id) => {
      try {
        let permissoes_ids = [];
        permissoes_ids.push(id);
        await store.dispatch("perfis/ativarPermissao", {
          permission_ids: permissoes_ids,
          role_id: detalhesRole.value.id,
        });
        quasar.notify({
          message: "Permissão ativada",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao ativar permissão",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };
    const desativarPermissao = async (id) => {
      disable.value = true;
      try {
        let permissoes_ids = [];
        permissoes_ids.push(id);
        await store.dispatch("perfis/desativarPermissao", {
          permission_ids: permissoes_ids,
          role_id: detalhesRole.value.id,
        });
        quasar.notify({
          message: "Permissão desativada",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao desativar permissão",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const voltar = async () => {
      router.push({ name: "perfis-papeis" });
    };

    watch(
      () => busca.value,
      () => {
        listarPermissoes();
      }
    );

    onMounted(listarRole);
    onMounted(listarPermissoes);

    return {
      listarRole,
      detalhesRole,
      columns,
      selected,
      permissoes,
      listarPermissoes,
      paginarTabela,
      loading,
      disable,
      verificarEstado,
      ativarPermissao,
      desativarPermissao,
      voltar,
      busca,
    };
  },
};
</script>

<style scoped>
.cursor {
  cursor: pointer;
  margin-top: 3px;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 14px;
  }
  .cursor {
    margin-top: 13px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .container-input-search {
    margin: 17px 0px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 14px;
  }
}
</style>
